import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

/**
 * Gọi API lấy danh sách ti hơi
 * @param {Object} [values] Tham số truyền vào
 * @param {string} [values.orientation='horizontal'] Hướng cửa, ti hơi chỉ trả về khi là 'horizontal'
 * @param {number} values.offset Vị trí bắt đầu lấy dữ liệu
 * @param {number} values.limit Số lượng dữ liệu lấy về
 */
export const fetchLiftSupport = createAsyncThunk(
  'get/modules/v3/lift-support',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `modules/v3/lift_support_setting`,
        method: 'get',
        params: { orientation: values?.orientation ?? 'horizontal' },
      });

      const response = res.data;
      if (response.success) {
        const data = response?.result?.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return { error: error.message };
    }
  }
);
